export default (theme) => ({
  formControl: {
    marginTop: 20,
    width: '100%',
  },
  formGroup: {
    marginTop: 10,
  },
  checkbox: {
    padding: 5,
  },
  option: {
    minWidth: '30%',
    width: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: '45%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  checkboxLabel: {
    color: theme.palette.font.main,
  },
  activeCheckboxLabel: {
    color: '#000000',
  },
});
